// extracted by mini-css-extract-plugin
export default {"tabs":"returnTabs_tabs__-vXAd","tab":"returnTabs_tab__8yXjv","glider":"returnTabs_glider__fMirz"};